/* global Blockly */

import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';
import util from '../../../../../../utils/es5Utils'

function defineBlock(context) {
    let prop = {...context};
    prop.tooltipText = "Execute a single MobiControl legacy script command on the device (e.g. disconnect, devrename newDeviceName, notify kiosk on). The Execute MobiControl Script JS API is available within lockdown apps.";
    prop.responseText = "result";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);

    // override default fields
    blockInstance.addFields = function() {
        this.appendValueInput("VALUE")
            .appendField("execute MC legacy script")
            .setCheck("String");
    }
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            let value = util.parseString(Blockly.JavaScript.valueToCode(block, "VALUE", Blockly.JavaScript.ORDER_NONE));
            // JSON.stringify safely escapes quotes/backslashes for embedding in the generated code string
            return `Snap.mcLockdown.executeMCScript(${JSON.stringify(value)}, ${coreResponseCode});\n`;
        }
    }
}

const MobiControlExecuteMCLegacyScript = function (props) {
    const name = 'snap_mobicontrol_executemclegacyscript';
    MobiControlExecuteMCLegacyScript.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return  <block type={name}>
                <value name="VALUE">
                    <shadow type="text"></shadow>
                </value>
            </block>;
}

export default MobiControlExecuteMCLegacyScript;

MobiControlExecuteMCLegacyScript.propTypes = {
    context: PropTypes.object
};
